<template>
    <div class="page-container" :class="{ collapsed: !$store.getters.sidebarOpened }">
        <div class="area-container left-area">
            <CommonTree
                type="room"
                :showFilter="true"
                @change="handleNodeClick"
                :customStyle="{ borderRight: 'none', width: '100%' }"
            />
        </div>
        <div class="data-container center-area">
            <div class="tool-box">
                <el-button type="primary" :icon="Refresh" @click="resetQueryForm">刷新</el-button>
                <el-button v-if="!isYuanKong" :icon="Timer" plain @click="uploadCycle(selected_ids, 30)">上报周期</el-button>
                <el-button v-if="!isYuanKong" :icon="Sunny" @click="temperatureCompensation(selected_ids, 0)">温度补偿</el-button>
                <el-button v-if="!isYuanKong" :icon="Upload" @click="reportUrl">上报地址</el-button>
                <el-button :icon="Switch" @click="SwitchSettings(selected_ids, 0)">开关设置</el-button>
                <el-button v-if="!isYuanKong" :icon="Setting" @click="openSchedule">定时开关机设置</el-button>
                <el-button v-if="!isYuanKong" :icon="Setting" @click="handleSetting">高级设置</el-button>
                <el-button v-if="!isYuanKong" :icon="RefreshLeft" @click="handleRestart(selected_ids)">重启</el-button>
                <el-button v-if="!isYuanKong" :icon="UploadFilled" @click="handleUpgrade(selected_ids)">升级</el-button>
            </div>
            <el-form class="search-form" ref="search_form" :inline="true" :model="search_params" label-position="top">
                <el-form-item label="名称" prop="name">
                    <el-input style="width: 165px" v-model="search_params.name" clearable placeholder="请输入名称" />
                </el-form-item>
                <el-form-item label="状态" prop="online">
                    <el-select v-model="search_params.online" placeholder="请选择状态" style="width: 165px" clearable>
                        <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.name"
                            :value="Number(item.value)"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="IMEI" prop="IMEI">
                    <el-input style="width: 165px" placeholder="请输入IMEI" v-model="search_params.IMEI" clearable />
                </el-form-item>
                <el-form-item label="ICCID" prop="ICCID">
                    <el-input style="width: 165px" placeholder="请输入ICCID" v-model="search_params.ICCID" clearable />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :icon="Search" plain @click="getTableData">搜索</el-button>
                    <el-button :icon="Refresh" @click="resetQueryForm">重置</el-button>
                </el-form-item>
            </el-form>
            <el-table
                class="data-table"
                :data="table_data"
                v-loading="tableLoading"
                row-key="id"
                :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
                @selection-change="handleSelectionChange"
                :header-cell-style="{ textQAlign: 'center' }"
            >
                <el-table-column type="selection" width="55" :selectable="checkSelectable" />
                <!-- <el-table-column type="selection" width="55" /> -->
                <!-- <el-table-column label="户名" fixed="left" prop="name" width="150" show-overflow-tooltip></el-table-column> -->
                <el-table-column label="名称" width="150px" prop="name" align="center"></el-table-column>
                <el-table-column label="IMEI" width="150px" prop="IMEI" align="center"></el-table-column>
                <el-table-column label="设备状态" width="90" prop="online" align="center">
                    <template #default="{ row }">
                        <el-tag v-if="row.online" type="success">在线</el-tag>
                        <el-tag v-else type="danger">离线</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="开关状态" width="90" prop="real_time_status.switch" align="center">
                    <template #default="{ row }">
                        <el-tag v-if="row.real_time_status?.switch" type="success">开</el-tag>
                        <el-tag v-else type="info">关</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="运行模式" width="100px" prop="real_time_status.run_mode" align="center">
                    <template #default="{ row }">
                        {{ run_mode.find((item) => item.value === row.real_time_status?.run_mode)?.label || '--' }}
                    </template>
                </el-table-column>
                <el-table-column label="设置温度(℃）" width="160" prop="temp" align="center">
                    <template #default="{ row }">
                        <span>{{ row.set_temp ?? '--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="风速状态" width="100px" prop="real_time_status.wind_speed" align="center">
                    <template #default="{ row }">
                        {{ speed.find((item) => item.value === row.real_time_status?.wind_speed)?.label || '--' }}
                    </template>
                </el-table-column>
                <el-table-column label="温度补偿(℃）" width="160" prop="temp_compensation" align="center">
                    <template #default="{ row }">
                        <span>{{ row.temp_compensation }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="湿度补偿（%RH）" width="160" prop="humidity_compensation" align="center">
                    <template #default="{ row }">
                        <span>{{ row.hum_compensation }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="锁定状态" width="150" prop="real_time_status.lock" align="center">
                    <template #default="{ row }">
                        {{ lockOptions.find((item) => item.value === row.real_time_status?.lock)?.label || '--' }}
                    </template>
                </el-table-column>
                <el-table-column label="节能模式" width="150" prop="set_energy" align="center">
                    <template #default="{ row }">
                        {{ row.set_energy ? '开' : '关' }}
                    </template>
                </el-table-column>
                <el-table-column label="房卡使能" width="150" prop="set_room_card" align="center">
                    <template #default="{ row }">
                        {{ room_card_status.find((item) => item.value === row.room_card)?.label || '--' }}
                    </template>
                </el-table-column>
                <el-table-column label="计费使能" width="150" prop="main_ac" align="center">
                    <template #default="{ row }">
                        {{ row.main_ac ? '使能' : '不使能' }}
                    </template>
                </el-table-column>
                <el-table-column label="上报周期(分钟)" width="160" prop="period" align="center">
                    <template #default="{ row }">
                        <span>{{ row.period ?? '--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="同步方式" width="160" prop="sync_type" align="center">
                    <template #default="{ row }">
                        <span>{{ row.sync_type === 1 ? '异步' : row.sync_type === 2 ? '同步' : '' }}</span>
                    </template>
                </el-table-column>

                <el-table-column label="设置温度上线" width="160" prop="upper" align="center">
                    <template #default="{ row }">
                        <span>{{ row.upper ?? '--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="设置温度下线" width="160" prop="floor" align="center">
                    <template #default="{ row }">
                        <span>{{ row.floor ?? '--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="安装位置" min-width="200" prop="location" show-overflow-tooltip>
                    <template #default="{ row }">
                        <span>{{ room_list[row.room] }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="ICCID" width="200" prop="ICCID" align="center"></el-table-column>

                <el-table-column label="操作" fixed="right" :width="isYuanKong ? 100 : 350" align="center">
                    <template #default="{ row }">
                        <!-- <el-button type="primary" link size="small" @click="handleSetting(row)">高级设置</el-button> -->
                        <el-button v-if="!isYuanKong" type="primary" link size="small" @click="uploadCycle([row.id], row.period)">
                            上报周期
                        </el-button>
                        <el-button
                            v-if="!isYuanKong"
                            type="primary"
                            link
                            size="small"
                            @click="temperatureCompensation(row.id, row.temp_compensation)"
                        >
                            温度补偿
                        </el-button>
                        <el-button v-if="!isYuanKong" type="primary" link size="small" @click="reportUrl(row)">
                            上报地址
                        </el-button>
                        <el-button type="primary" link size="small" @click="SwitchSettings(row.id, row.set_switch)">
                            开关设置
                        </el-button>
                        <el-button
                            v-if="!isYuanKong"
                            type="primary"
                            link
                            size="small"
                            @click="openSchedule(row)"
                            :disabled="!row.group"
                        >
                            定时开关
                        </el-button>
                        <!-- <el-button type="primary" link size="small" @click="handleRestart(row.id, row.restart)">重启</el-button>
                        <el-button type="primary" link size="small" @click="handleUpgrade(row.id)">升级</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <Pagination
                v-if="table_data.length > 0"
                :current-page="page_params.page"
                :page-size="page_params.page_size"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            />
            <water-temp v-if="temp_dialog_show" v-model="temp_dialog_show" :detailData="temp_detail" @updateForm="getTableData" />
            <AdvancedForm
                v-if="advancedFormShow"
                v-model="advancedFormShow"
                ref="advancedFormRef"
                :formDatail="temp_detail"
                :formIds="selected_ids"
                @updateForm="getTableData"
            />
            <UpgradeFileSelect
                v-if="selectUpgradeVisible"
                v-model="selectUpgradeVisible"
                :module="'tour'"
                @getSelectUpgrade="getSelectUpgrade"
            ></UpgradeFileSelect>
            <ScheduleSetting ref="scheduleRef" @refresh="getTableData" />
        </div>
    </div>
</template>

<script setup>
import { h, onMounted, reactive, ref, computed } from 'vue'
import { Refresh, RefreshLeft, Search, Setting, Sunny, Switch, Timer, Upload } from '@element-plus/icons'
import { batchPatchValveParams, getDeviceList, upgradeFileApi } from '@/api/thermostat/devicePoint.js'
import Pagination from '@/components/Pagination/index.vue'
import CommonTree from '@/components/BuildTree/CommonTree.vue'
import { getEquipModelTree } from '@/api/equipment.js'
import { getOptionTree } from '@/api/room.js'
import { ElInputNumber, ElMessage, ElMessageBox, ElSwitch, ElInput } from 'element-plus'
import WaterTemp from '@/views/control-valve/params-config/batchConfig/components/WaterTemp.vue'
import AdvancedForm from './components/AdvancedForm.vue'
import { lockOptions, speed, run_mode, room_card_status } from '@/constant/index.js'
import UpgradeFileSelect from '@/views/thermostat/update-files-manage/components/SelectUpgradeList.vue'
import { UploadFilled } from '@element-plus/icons-vue'
import ScheduleSetting from './components/ScheduleSetting.vue'
import { getItem } from '@/utils/storage'
// 是否为源控
const isYuanKong = computed(() => getItem('userInfo')?.name === '源控')
const scheduleRef = ref(null)

const openSchedule = (data) => {
    scheduleRef.value.open(data)
}
const advancedFormShow = ref(false)
// 批量升级
const selectUpgradeVisible = ref(false)
const selectedGatewauyList = ref([])
const handleUpgrade = async (row) => {
    let ids = []
    if (typeof row === 'object' && row.length === 0) {
        ElMessage.error('请选择设备')
        return
    } else {
        ids = Array.isArray(row) ? row : [row]
    }

    // ElMessageBox.confirm('您确定要升级该设备吗？', {
    //     type: 'warning',
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消'
    // })
    //     .then(async () => {
    selectUpgradeVisible.value = true
    selectedGatewauyList.value = ids
    //     })
    //     .catch(() => {})
}
// 获取选中的升级文件
const getSelectUpgrade = async (data) => {
    console.log('🚀 ~ getSelectUpgrade ~ data:', data)
    if (data?.id) {
        try {
            await upgradeFileApi({
                id_list: selectedGatewauyList.value,
                file_id: data.id
            })
            ElMessage.success('升级成功')
            selectUpgradeVisible.value = false
            selectedGatewauyList.value = []
        } catch (error) {}
    }
}
const handleSetting = () => {
    if (selected_ids.value.length === 0) {
        ElMessage.error('请选择设备')
        return
    }
    if (selected_ids.value.length === 1) {
        temp_detail.value = table_data.value.find((item) => item.id === selected_ids.value[0])
        advancedFormShow.value = true
    } else {
        temp_detail.value = {}
        advancedFormShow.value = true
    }
}
// 型号列表
const model_list = ref({})
async function getModelList() {
    await getEquipModelTree().then((data) => {
        const list = {}
        data.forEach((device_type) => {
            device_type?.children?.forEach((device_model) => {
                list[device_model.id] = {
                    type: device_type.name,
                    model: device_model.name
                }
            })
        })
        model_list.value = list
    })
}

// 安装位置
const room_list = ref({})
async function getRoomTree() {
    await getOptionTree().then((data) => {
        const room_locations = {}
        function getRoom(list, location) {
            list?.forEach((item) => {
                if (item.children) {
                    getRoom(item.children, location + '/' + item.name)
                } else {
                    room_locations[item.id] = location.slice(1) + '/' + item.name
                }
            })
        }
        getRoom(data ? data[0]?.children : [], '')
        room_list.value = room_locations
    })
}

// 状态列表
const statusList = [
    { name: '在线', value: 1 },
    { name: '离线', value: 0 }
]

// 左侧区域树
const current_node = ref({})
const handleNodeClick = (data) => {
    current_node.value = data
    resetQueryForm()
}

// 重置
const search_form = ref(null)
const resetQueryForm = () => {
    search_form.value.resetFields()
    getTableData()
}
// 数据源
const search_params = reactive({
    name: '',
    online: null,
    IMEI: '',
    ICCID: '',
    model: ''
})

const table_data = ref([])
const tableLoading = ref(true)
const total = ref(0)

// 获取列表数据
async function getTableData() {
    tableLoading.value = true
    const params = { ...search_params, ...page_params }
    if (current_node.value?.id) {
        if (current_node.value?.node_type !== undefined) {
            params.building = current_node.value.id
        } else {
            params.room = current_node.value.id
        }
    }
    getDeviceList(params).then((data) => {
        table_data.value = data.lists
        total.value = data.total
        tableLoading.value = false
    })
}
const checkSelectable = (row, index) => {
    return row.online
}

// 分页相关
const page_params = reactive({
    page: 1,
    page_size: 10
})
const handleSizeChange = (currentSize) => {
    page_params.page_size = currentSize
    page_params.page = 1
    getTableData()
}
const handleCurrentChange = (currentPage) => {
    page_params.page = currentPage
    getTableData()
}

// 表格项被勾选
const selected_ids = ref([])
function handleSelectionChange(rows) {
    selected_ids.value = rows.map((item) => item.id)
}

// 水温设置
const temp_dialog_show = ref(false)
const temp_detail = ref({})
function tempSetting(ids, row) {
    if (ids.length === 0) {
        ElMessage.error('请选择设备')
        return false
    }
    temp_detail.value = {
        id_list: ids,
        ...row
    }
    temp_dialog_show.value = true
}

// 上传周期
function uploadCycle(ids, value) {
    if (ids.length === 0) {
        ElMessage.error('请选择设备')
        return false
    }
    const checked = ref(value)
    const placeholder_value = ref('未知')
    ElMessageBox({
        title: '上传周期',
        message: () => {
            return h('div', {}, [
                h(ElInputNumber, {
                    modelValue: checked.value,
                    min: 1,
                    max: 2880,
                    'onUpdate:modelValue': (val) => {
                        checked.value = val
                        if (!val) {
                            placeholder_value.value = ''
                        }
                    },
                    placeholder: placeholder_value.value
                }),
                h('span', ' 分钟')
            ])
        },
        beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
                if (checked.value) {
                    instance.confirmButtonLoading = true
                    batchPatchValveParams({
                        id_list: ids,
                        period: checked.value
                    })
                        .then(() => {
                            instance.confirmButtonLoading = false
                            ElMessage.success('设置成功！')
                            getTableData()
                            done()
                        })
                        .catch(() => {
                            instance.confirmButtonLoading = false
                        })
                } else {
                    ElMessage.error('请输入上百周期')
                    instance.confirmButtonLoading = false
                }
            } else {
                done()
            }
        }
    })
}
// 温度补偿
function temperatureCompensation(id, value) {
    const checked = ref(!!value)
    if (typeof id === 'object' && id.length === 0) {
        return ElMessage.error('请选择设备')
    }
    ElMessageBox({
        title: '温度补偿值',
        message: () => {
            return h('div', {}, [
                h(ElInputNumber, {
                    modelValue: checked.value,
                    min: -9,
                    max: 9,
                    precision: 1,
                    step: 0.1,
                    'onUpdate:modelValue': (val) => {
                        checked.value = val
                    }
                }),
                h('span', ' ℃')
            ])
        },
        beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
                if (checked.value !== null) {
                    instance.confirmButtonLoading = true
                    batchPatchValveParams({
                        id_list: typeof id === 'object' ? id : [id],
                        temp_compensation: checked.value
                    })
                        .then(() => {
                            instance.confirmButtonLoading = false
                            ElMessage.success('设置成功！')
                            getTableData()
                            done()
                        })
                        .catch(() => {
                            instance.confirmButtonLoading = false
                        })
                } else {
                    ElMessage.error('请输入温度补偿值')
                    instance.confirmButtonLoading = false
                }
            } else {
                done()
            }
        }
    })
}
// 上报地址
function reportUrl(data) {
    let initValues = data
    // 1. 必选：校验设备 ID，无 ID 直接返回（提前拦截，避免后续提交无意义）
    if (!initValues?.id && selected_ids.value.length === 0) {
        return ElMessage.error('请选择设备')
    }
    // 统一处理 ID 列表（提前缓存，避免多次判断）
    const idList = initValues?.id ? [initValues.id] : selected_ids.value

    // 2. 使能状态：0→false / 1→true（适配 Switch 布尔值）
    const svrInfoEn = ref(initValues?.svr_info_en === 1 ? true : false)
    // 初始化标志位：防止弹窗打开时触发提交
    const isInit = ref(true)

    const form = ref({
        reportAddress: initValues.server_url || '',
        port: initValues.server_port || '80',
        username: initValues.connect_username || '',
        password: initValues.connect_pwd || ''
    })

    // 3. 开关切换提交逻辑（增加日志 + 强校验）
    // const handleSvrEnChange = async (newValue) => {
    //     console.log('开关触发change，值为：', newValue, '初始化状态：', isInit.value)
    //     try {
    //         // 必选：await 确保接口执行完成
    //         await batchPatchValveParams({
    //             id_list: idList, // 使用缓存的 ID 列表
    //             svr_info_en: newValue ? 1 : 0
    //         })
    //         // 提交成功：更新本地状态 + 提示 + 刷新列表
    //         svrInfoEn.value = newValue
    //         ElMessage.success(`服务器信息修改已${newValue ? '使能' : '关闭'}`)
    //         getTableData()
    //     } catch (error) {
    //         // 错误日志：方便排查接口问题
    //         console.error('开关提交接口失败：', error)
    //         // 回滚状态：保证前端显示和后端一致
    //         svrInfoEn.value = !newValue
    //         ElMessage.error('状态更新失败，请检查接口或重试')
    //     }
    // }

    ElMessageBox({
        title: '设置上报信息',
        message: () => {
            return h('div', { style: 'display: flex; flex-direction: column; gap: 16px;' }, [
                // 服务器信息修改使能 Switch
                // h('div', { style: 'display: flex; align-items: center; gap: 8px;' }, [
                //     h('span', { style: 'width: 80px; text-align: right;' }, '修改使能：'),
                //     h(ElSwitch, {
                //         modelValue: svrInfoEn.value,
                //         activeValue: true, // Switch 原生布尔值，避免类型混乱
                //         inactiveValue: false,
                //         activeText: '使能',
                //         inactiveText: '不使能',
                //         style: 'flex: 1; max-width: 250px;',
                //         // 核心：切换时先触发状态更新，再提交
                //         'onUpdate:modelValue': handleSvrEnChange
                //     })
                // ]),
                // 原有表单项（保持不变）
                h('div', { style: 'display: flex; align-items: center; gap: 8px;' }, [
                    h('span', { style: 'width: 80px; text-align: right;' }, '上报地址：'),
                    h(ElInput, {
                        modelValue: form.value.reportAddress,
                        placeholder: '请输入上报地址（IP或域名）',
                        style: 'flex: 1;width: 250px;',
                        'onUpdate:modelValue': (val) => {
                            form.value.reportAddress = val
                        }
                    })
                ]),
                h('div', { style: 'display: flex; align-items: center; gap: 8px;' }, [
                    h('span', { style: 'width: 80px; text-align: right;' }, '端口：'),
                    h(ElInputNumber, {
                        modelValue: form.value.port,
                        defaultValue: 80,
                        min: 1,
                        max: 65535,
                        placeholder: '请输入端口（1-65535）',
                        style: 'flex: 1;width: 250px;',
                        'onUpdate:modelValue': (val) => {
                            form.value.port = val
                        }
                    })
                ]),
                h('div', { style: 'display: flex; align-items: center; gap: 8px;' }, [
                    h('span', { style: 'width: 80px; text-align: right;' }, '账号：'),
                    h(ElInput, {
                        modelValue: form.value.username,
                        placeholder: '请输入登录账号',
                        style: 'flex: 1;width: 250px;',
                        'onUpdate:modelValue': (val) => {
                            form.value.username = val
                        }
                    })
                ]),
                h('div', { style: 'display: flex; align-items: center; gap: 8px;' }, [
                    h('span', { style: 'width: 80px; text-align: right;' }, '密码：'),
                    h(ElInput, {
                        modelValue: form.value.password,
                        type: 'password',
                        placeholder: '请输入登录密码',
                        style: 'flex: 1;width: 250px;',
                        'onUpdate:modelValue': (val) => {
                            form.value.password = val
                        }
                    })
                ])
            ])
        },
        // 关键：弹窗完全打开后再关闭初始化标志
        onOpened: () => {
            console.log('弹窗已打开，关闭初始化标志')
            isInit.value = false
        },
        beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
                const { reportAddress, port, username, password } = form.value
                if (!reportAddress || !port || !username || !password) {
                    ElMessage.error('请完善上报信息！')
                    instance.confirmButtonLoading = false
                    return
                }

                instance.confirmButtonLoading = true
                try {
                    await batchPatchValveParams({
                        id_list: idList,
                        server_url: reportAddress,
                        server_port: port,
                        connect_username: username,
                        connect_pwd: password
                    })
                    instance.confirmButtonLoading = false
                    ElMessage.success('上报信息设置成功！')
                    getTableData()
                    done()
                } catch (error) {
                    instance.confirmButtonLoading = false
                    ElMessage.error('设置失败，请重试！')
                    console.error('表单提交接口失败：', error)
                }
            } else {
                done()
            }
        }
    })
}

// 采集周期
function acquisitionCycle(ids, value) {
    if (ids.length === 0) {
        ElMessage.error('请选择设备')
        return false
    }
    const checked = ref(value)
    const placeholder_value = ref('未知')
    ElMessageBox({
        title: '采集周期',
        message: () => {
            return h('div', {}, [
                h(ElInputNumber, {
                    modelValue: checked.value,
                    min: 1,
                    max: 2880,
                    'onUpdate:modelValue': (val) => {
                        checked.value = val
                        if (!val) {
                            placeholder_value.value = ''
                        }
                    },
                    placeholder: placeholder_value.value
                }),
                h('span', ' 分钟')
            ])
        },
        beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
                if (checked.value) {
                    instance.confirmButtonLoading = true
                    batchPatchValveParams({
                        id_list: ids,
                        acquisition_cycle: checked.value
                    })
                        .then(() => {
                            instance.confirmButtonLoading = false
                            ElMessage.success('设置成功！')
                            getTableData()
                            done()
                        })
                        .catch(() => {
                            instance.confirmButtonLoading = false
                        })
                } else {
                    ElMessage.error('请输入上传周期')
                    instance.confirmButtonLoading = false
                }
            } else {
                done()
            }
        }
    })
}

// 开关设置
function SwitchSettings(id, value) {
    const checked = ref(!!value)
    if (typeof id === 'object' && id.length === 0) {
        return ElMessage.error('请选择设备')
    }
    ElMessageBox({
        title: '开关设置',
        message: () => {
            return h(ElSwitch, {
                modelValue: checked.value,
                activeText: '开',
                inactiveText: '关',
                'onUpdate:modelValue': (val) => {
                    checked.value = val
                }
            })
        },
        beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
                batchPatchValveParams({
                    id_list: typeof id === 'object' ? id : [id],
                    set_switch: checked.value ? 1 : 0
                })
                    .then(() => {
                        instance.confirmButtonLoading = false
                        ElMessage.success('设置成功！')
                        getTableData()
                        done()
                    })
                    .catch(() => {
                        instance.confirmButtonLoading = false
                    })
            } else {
                done()
            }
        }
    })
}
// 重启
function handleRestart(id, value) {
    let ids = []
    if (typeof id === 'object') {
        if (id.length === 0) {
            return ElMessage.error('请选择设备')
        }
        ids = id
    } else {
        ids = [id]
    }
    ElMessageBox.confirm('是否确认重启？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
    })
        .then(() => {
            batchPatchValveParams({
                id_list: ids,
                restart: 1
            })
                .then(() => {
                    instance.confirmButtonLoading = false
                    ElMessage.success('操作成功！')
                    getTableData()
                    done()
                })
                .catch(() => {
                    instance.confirmButtonLoading = false
                })
        })
        .catch(() => {})
}

// // 设备升级
// function handleDeviceUpgrade(ids) {
//     ElMessageBox.confirm('是否确认升级设备？', '提示', {
//         confirmButtonText: '确定',
//         cancelButtonText: '取消',
//         type: 'warning'
//     }).then(() => {
//         devicesUpgrade({
//             type: 3,
//             id_list: ids
//         }).then(() => {
//             ElMessage.success('操作成功！')
//         })
//     })
// }

// 切换到前台时候执行
onMounted(() => {
    getModelList()
    getRoomTree()
    getTableData()
})
</script>

<style scoped></style>
